import includes from 'lodash/includes';
import toLower from 'lodash/toLower';
import trim from 'lodash/trim';
import type { IDropdownOptions } from '@/Interfaces/Data';

export const formatString = (word: string) => trim(toLower(word));

export const caseInsensitiveSearch = (
  options: IDropdownOptions[],
  query: string,
) => {
  const newQuery = formatString(query);

  return options.filter(
    opt =>
      includes(formatString(opt.value), newQuery) ||
      includes(formatString(opt.text), newQuery) ||
      includes(formatString(opt.key), newQuery),
  );
};
